module.exports = __webpack_public_path__ + "static/media/card-1.1cfee434.jpeg";